import {gql} from "@apollo/client";

export const FETCH_STAYS = gql`
    query stays {
        stays {
            id
            name
            description
            stayType
            price
            number
            numberOfGuests
            location
        }
    }
`;

export const SAVE_OR_UPDATE_STAY = gql`
    mutation saveStay($input: SaveStayInput! $aantal: Int!) {
        saveStay(input: $input aantal: $aantal)
    }
`;

export const DELETE_STAY = gql`
    mutation deleteStay($id: Int!) {
        deleteStay(id:$id)
    }
`;
